import styled from 'styled-components';

/** Capped in height so a noisy run doesn't blow out the node card. */
export const ArtifactList = styled.ul.attrs<{ $expanded?: boolean }>(
  // React Flow's pane consumes the wheel to zoom, so an overflowing list needs
  // `nowheel` to be scrollable at all. Gated on expanded because the collapsed
  // cap never overflows — claiming the wheel there would only break zooming.
  ({ $expanded }) => ({ className: $expanded ? 'nowheel' : undefined }),
)<{ $expanded?: boolean }>`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: ${({ $expanded }) => ($expanded ? '280px' : '140px')};
  overflow-y: auto;
`;

export const ArtifactRow = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
`;

export const ArtifactName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ArtifactDownloadButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
  cursor: pointer;
  font: inherit;
  font-size: 11px;
  padding: 0;
  text-decoration: underline;

  &:disabled {
    cursor: progress;
    opacity: 0.6;
    text-decoration: none;
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
    outline-offset: 2px;
  }
`;

export const ArtifactsMore = styled.button.attrs({
  type: 'button',
  className: 'nodrag nopan',
})`
  font: inherit;
  font-size: 10px;
  color: ${({ theme: { colors = {} } }) => colors.onSurfaceVariant ?? '#9A95B0'};
  text-align: center;
  padding: 2px 0 0;
  width: 100%;
  background: transparent;
  border: 0;
  cursor: pointer;

  &:hover {
    color: ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme: { colors = {} } }) => colors.primary ?? '#C1C1FF'};
    outline-offset: 2px;
  }
`;
